export default {
	isEditing: false,
	isSaving: false
};



// WEBPACK FOOTER //
// ./src/reducers/leaflet/leaflet-initialState.js